module.exports = __webpack_public_path__ + "media/country_flags/sz-670fd35c.png";